







import {Vue, Component} from 'vue-property-decorator'
import {formatDate} from "@/utils/formatters";
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";

@Component({})
export default class PonovnePosete extends mixins(ComponentBaseMixin) {
  ponovnePosete = [];
  columns = [];
  tableOptions = {
    pagination: true,
    showRefresh: true
  };

  created() {
    this.columns = [
      {field: 'createdOn', title: this.$i18n.t('kreiran'), formatter: formatDate},
      {field: 'revisitDate', title: this.$i18n.t('ponovnaPoseta'), formatter: formatDate},
      {field: 'lastVisit', title: this.$i18n.t('poslednjaPoseta'), formatter: formatDate},
      {
        field: 'daysLate',
        title: this.$i18n.t('kasniDana'),
        cellStyle: (value) => value >= 0 ? {css: {'color': 'red'}} : ''
      },
      {field: 'purpose', title: this.$i18n.t('svrha'), formatter: formatDate},
      {field: 'storeName', title: this.$i18n.t('objekat'), formatter: formatDate},
      {field: 'storeCity', title: this.$i18n.t('mesto'), formatter: formatDate},
      {field: 'notify', title: this.$i18n.t('odgovoran'), formatter: formatDate},
    ];
  }

  mounted() {
    this.loadRevisits();

    $('#revisitsTable').on('refresh.bs.table', () => {
      this.loadRevisits();
    });
  }

  async loadRevisits() {
    this.ponovnePosete = [];
    let table = $('#revisitsTable');
    table.bootstrapTable('showLoading');
    await this.axios.get('api/revisits?order=asc&limit=10&offset=0').then((result) => {
      this.ponovnePosete = result.data;
    }).catch((er) => {
      this.showError('neuspesnoUcitavanjePodataka');
      table.bootstrapTable('hideLoading');
    }).finally(() => {
      table.bootstrapTable('hideLoading');
    });
  }
}
